import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, DBDropDown, DBTextField, DBDateField } from '_components';
import { getDateMMDDYYYY } from '_helpers';
import styles from './Common.module.css';
import { PatientCareCenterNoteNavAnchor } from '../../NavAnchor';

class PatientCareCenterNoteGoalsLTGDetails extends React.Component {


    deleteGoal() {
        this.props.updateBitField(this.props.noteId, 'PTGOALS', 'GONO', this.props.id, 'GODELETED', true);
        if (!this.props.goalsUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }

    copyProgress() {
        this.props.updateIntField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOGPNO', this.props.goal.GOGPNOPREV);
    }


    render() {
        return (
            <PatientCareCenterNoteNavAnchor id={'goal_' + this.props.goal.GONO} >
                <div className={styles.goal_detail_row}>
                    <span className={styles.goal_detail_col1}>
                        {(!this.props.isPrevGoal || this.props.isSpeech) &&
                            <CancelButton title='Delete Goal' size='extra-small' onClick={() => this.deleteGoal()} />
                        }
                    </span>
                    {/* Activity */}
                    <div className={styles.ltg_activity}>
      
                        <DBTextField
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.goal.GONO}
                            field='GOOBJECTIVE'
                            className={this.props.descReq ? styles.text_field_req : styles.text_field}
                            disabled={this.props.goalMet}
                            placeholder='Describe or quantify goal'
                        />
                
                    
                    </div>
                    
                    {/* DATE */}
                    <div className={styles.stg_date}>
                        <span className={styles.date_field}>
                        
                             <DBDateField
                                    noteId={this.props.noteId}
                                    entity='PTGOALS'
                                    entityKeyColumn='GONO'
                                    entityKeyValue={this.props.goal.GONO}
                                    maxDate={new Date().setFullYear(new Date().getFullYear() + 1)}
                                    field='GODATE'
                                    disabled={this.props.noteType === 2}
                                    customMsg='The goal date cannot be in the past.'
                                    minDate={getDateMMDDYYYY(new Date())}
                                    defaultdate={this.props.days}
                                    required={this.props.dateReq}
                                />
                        </span>
                    </div>

                </div>
            </PatientCareCenterNoteNavAnchor>

        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let goal = state.entities.notes.PTGOALS[ownprops.id];
    let goalsUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTGOALSUPDATED : true;
    let descReq = (noteType === 1 || noteType === 3 || noteType === 5) && !goal.GOOBJECTIVE ? true : false;
    let days = ownprops.days;
    let dateReq = noteType !== 2 && !goal.GODATE ? true : false;
    let defaultDate = ownprops.days ?? 0;
    return {
        noteId,
        noteType,
        pk,
        descReq,
        dateReq,
        goal,
        goalsUpdated,
        isPrevGoal: goal.GOGONO ? true : false,
        defaultDate,
        days
    };
}

const connectedPatientCareCenterNoteGoalsLTGDetails = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsLTGDetails);
export { connectedPatientCareCenterNoteGoalsLTGDetails as PatientCareCenterNoteGoalsLTGDetails };

